import Button from '@mui/material/Button';
import './ButtonLayout.css';

const ButtonLayout = (props) => {
    return (
        <Button href={props.href} variant="contained" sx={props.sx} disabled={props.disabled} className={
            props.className ? `button-style ${props.className}` : "button-style"
        } onClick={props.onClickBtn}>
            {props.label}
        </Button>
    )
}

export default ButtonLayout